import React, { useState, useEffect, useContext } from 'react'
import EventoFila from './EventoFila/EventoFila.js'
import { addDays, getURLBASE, getURLBasePath } from '../tools/utils.js';
import Loader from "react-js-loader";
import { ProductContext } from '../../context/ProductContext.jsx';
import axios from 'axios';

const ListadoEventos = () => {
  const [eventos, setEventos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const { setEvento } = useContext(ProductContext);

  useEffect(() => {
    //const url = `${getURLBasePath()}/serviciosEventos.php`;
    //const data = { peticion: 23, objeto: { llamadoDesde: 'W', queTipoDeProductos: 0, filtrarContenido: 1 } };
    


    // fetch(url, {
   
    //   method: 'GET',
    //   body: JSON.stringify(data),
    //   headers: new Headers()
    // })
    //   .then(res => res.json())
    //   .then(resultado => {
    //     console.log(resultado)
    //     if (resultado && resultado.estado === 'exito' && Array.isArray(resultado.data)) {
    //       setEventos(resultado.data);
    //       setLoaded(true);
    //     }
    //   })
    //   .catch(error => console.error('Error:', error));
   const ejecutarConsulta = async () => {

    const fechaFormateada = new Date().toLocaleDateString('fr-CA', {
      timeZone: 'America/Argentina/Buenos_Aires'
    });

    const data = {

      // peticion: 25, 
      // param: {
      // filtrarContenido: 1,
      // llamadoDesde: "W",
      // fechaActual: fechaFormateada,
      // queTipoDeProductos: 0
    //}
     peticion: 8
      
    
  }

  const url = `https://estanciamargarita.com.ar/backendBeta/php/servicios/serviciosProductoM.php`;

  fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: new Headers(),
  })
    .then((res) => res.json())
    
    .then((resultado) => {
      if (resultado) {
       // console.log(resultado)
       
        setEventos(resultado)
      //console.log(eventos)
       setLoaded(true)
      }
    })
    .catch((error) => console.error("Error:", error));
  

  //   try {
      
  //    const response = await axios.post(`https://estanciamargarita.com.ar/backendBeta/php/servicios/serviciosEvento.php`, data, {
      
  //    })
  //    //console.log(response.data.eventos)
  //    if(response.data && Array.isArray(response.data.eventos)){
  //     setEventos(response.data.eventos)
  //     //console.log(eventos)
  //     setLoaded(true)
  //    }
      
  //   } catch (error) {
  //     console.log(error)
  //   }
  //  finally {
  //   setLoaded(true)
  //  }

   }
   ejecutarConsulta()
  }, []);


  
  // const array_move = (arr, old_index, new_index) => {
  //   if (new_index >= arr.length) {
  //     var k = new_index - arr.length + 1;
  //     while (k--) {
  //       arr.push(undefined);
  //     }
  //   }
  //   arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  //   return arr;
  // };

  // const handleChangeEvento = (evento) => {
  //   setEvento(evento)

  // }
//let currentImgIndex = 0;

// const elegirFondo = () => {
//   const fondo = imagenes[currentImgIndex];
//   currentImgIndex = (currentImgIndex + 1) % imagenes.length;
//   return fondo;
// };
  // const filtrarEventosPorFecha = (fechaEvento) => {
  //   const eventoFecha = new Date(fechaEvento);
  //   eventoFecha.setHours(0, 0, 0, 0);
  
  //   const hoy = new Date();
  //   hoy.setHours(0, 0, 0, 0);
  
  //   const manana = new Date(hoy);
  //   manana.setDate(hoy.getDate() + 1);
  
  //   return (
  //     eventoFecha.getTime() === hoy.getTime() ||
  //     eventoFecha.getTime() === manana.getTime()
  //   );
  // };

  //const imagenes = [ 'images/reserva/arbolada.jpg', 'images/reserva/nenes.jpg', 'images/reserva/bienvenidos.jpg', 'images/reserva/carro.jpg', 'images/reserva/arbol.jpg'];

  const Cargador = () => (
    <div className="p-20  min-h-screen flex justify-center items-center">
      <div className="item">
        <Loader type="bubble-ping" bgColor={'#d5d5d5'} color={'#f4f4f4'} title={"Cargando Eventos."} size={150} />
      </div>
    </div>
  );
//console.log(eventos)
  
  return (
    <div className='md:pt-20'>
      
      {!loaded && <Cargador />}
      {eventos.map((evento, i) => {
     
        return (
          <EventoFila
            key={i}
            miEvento={evento}
           // onEventoClick={() => handleChangeEvento(evento)}
            imagen={evento.idProducto === 3 ? 'images/reserva/sintransporte.jpeg' : 'images/reserva/contransporte.jpeg' }
          />
        );
      })}
    </div>
  );
};

export default ListadoEventos;
